<div style="margin-top:24px;background: #000;">
    <!-- <div class="top-grid">
        <div fxLayout="row" fxLayoutGap="10px" style="background: #000;padding: 16px 0">
            <div style="position: relative;">
                <div style="position: absolute; top: 7px; left: 5px">
                    <mat-icon style="color: rgba(222, 222, 222, 0.2);">
                        search　
                    </mat-icon>
                </div>
                <input class="find" placeholder="Search" [(ngModel)]="name" (keypress)="$event.which === 13 ? searchLogList() : 0">
            </div>
            <div style="position: relative">
                <select name="status" style="width: 216px;height: 48px;background-color: #161616;border-radius: 6px;padding: 19px 12px;" [(ngModel)]="status" (change) = "searchLogList()">
                    <option value="all">All</option>
                    <option value="active">Active</option>
                    <option value="suspend">Suspend</option>
                    <option value="submitted">Submitted</option>
                    <option value="approved">Approved</option>
                    <option value="reject">Reject</option>
                    <option value="removed">Removed</option>
                </select>
                <div style="position: absolute;top: 8px;left: 8px;">Status</div>
            </div>
        </div>
    </div> -->


    <div class="table-title">
        <div style="width: 30%;margin-left: 25px">Agency</div>
        <div style="width: 30%">Contact</div>
        <div style="width: 10%">Status</div>
        <div style="width: 10%">Operator</div>
        <div style="width: 20%">Time</div>
    </div>

    <div>
        <!-- <div *ngFor="let item of content;let i = index" style="background: #fff">
            <div style="padding: 25px 24px;box-shadow: #b0b0b0 0 10px 10px -12px;border: 1px solid #f3f3f3">
                <div class="card-title" style="position: relative">
                    <div style="display: flex;align-items: center;justify-content: start;width: 30%">
                        <img style="width: 24px;height: 24px;margin-right: 10px"
                             [src]="SERVER_URL + 'images/company_' + item.id +  '/' + item.logo">
                        <div>
                            <div class="name">{{ item.name }}</div>
                            <div class="address">{{ item.addressLine2 }}{{ item.addressLine1 ? "," + item.addressLine1 : ''}}</div>
                        </div>
                    </div>

                    <div style="width: 30%">
                        <div class="name">{{ item.phoneNumber }}</div>
                        <div class="address">{{ item.email }}</div>
                    </div>

                    <div style="width: 10%">
                        <button mat-button class="status-pending" *ngIf="item.bizStatus === 'SUBMITTED'"
                                style="background: #DFC901">{{ item.bizStatus }}</button>
                        <button mat-button class="status-pending" *ngIf="item.bizStatus === 'APPROVED'"
                                style="background: #03BC79">{{ item.bizStatus }}</button>
                        <button mat-button class="status-pending" *ngIf="item.bizStatus === 'REJECT'"
                                style="background: #EA5050">{{ item.bizStatus }}</button>
                        <button mat-button class="status-pending" *ngIf="item.bizStatus === 'REMOVED'"
                                style="background: #EA5050">{{ item.bizStatus }}</button>
                        <button mat-button class="status-pending" *ngIf="item.bizStatus === 'ACTIVE'"
                                style="background: #388E3C">{{ item.bizStatus }}</button>
                        <button mat-button class="status-pending" *ngIf="item.bizStatus === 'SUSPEND'"
                                style="background: #DFC901">{{ item.bizStatus }}</button>
                    </div>

                    <div style="width: 10%" class="number">
                        {{ item.operator.firstName }}{{ item.operator.lastName }}
                    </div>

                    <div style="width: 20%" class="number">
                        {{ item.createTime | date:'HH:mm:ss dd/MM/yyyy' }}
                    </div>

                    <mat-icon (click)="open(item,i)"
                              style="position: absolute;right: 0px;cursor: pointer"
                              *ngIf="tableIndex == -1 || tableIndex != i">
                        keyboard_arrow_down
                    </mat-icon>
                    <mat-icon (click)="open(item,i)"
                              style="position: absolute;right: 0px;cursor: pointer"
                              *ngIf="tableIndex != -1 && tableIndex == i">
                        keyboard_arrow_up
                    </mat-icon>
                </div>
            </div>

            <div style="padding: 0 24px 34px 24px;margin-bottom: 20px" fxLayout="row" fxLayout.sm="column" fxLayoutAlign="start start" *ngIf="i === tableIndex">

            </div>
        </div>-->
        <mat-accordion class="example-headers-align">
            <mat-expansion-panel *ngFor="let item of content;let i = index" (opened)="getLogDetail(item)">
                <mat-expansion-panel-header style="border-bottom: 1px solid rgba(222, 222, 222, 0.2);background: #000;">
                    <div class="card-title" style="position: relative;">
                        <div style="display: flex;align-items: center;justify-content: start;width: 30%">
                            <img style="width: 24px;height: 24px;margin-right: 10px"
                                [src]="SERVER_URL + 'images/company_' + item.agencyId +  '/' + item.logo">
                            <div>
                                <div class="name">{{ item.name }}</div>
                                <div class="address">{{ item.addressLine2 }}{{ item.addressLine1 ? "," +
                                    item.addressLine1 : ''}}</div>
                            </div>
                        </div>
                        <span style="color: rgba(222, 222, 222, 0.2);margin-right:12px;">|</span>

                        <div style="width: 30%">
                            <div class="name">{{ item.phoneNumber }}</div>
                            <div class="address">{{ item.email }}</div>
                        </div>
                        <span style="color: rgba(222, 222, 222, 0.2);margin-right:12px;">|</span>

                        <div style="width: 10%">
                            <button mat-button class="status-pending" *ngIf="item.bizStatus === 'SUBMITTED'"
                                style="background: #DFC901">{{ item.bizStatus }}</button>
                            <button mat-button class="status-pending" *ngIf="item.bizStatus === 'APPROVED'"
                                style="background: #03BC79">{{ item.bizStatus }}</button>
                            <button mat-button class="status-pending" *ngIf="item.bizStatus === 'REJECT'"
                                style="background: #EA5050">{{ item.bizStatus }}</button>
                            <button mat-button class="status-pending" *ngIf="item.bizStatus === 'REMOVED'"
                                style="background: #EA5050">{{ item.bizStatus }}</button>
                            <button mat-button class="status-pending" *ngIf="item.bizStatus === 'ACTIVE'"
                                style="background: #388E3C">{{ item.bizStatus }}</button>
                            <button mat-button class="status-pending" *ngIf="item.bizStatus === 'SUSPEND'"
                                style="background: #DFC901">{{ item.bizStatus }}</button>
                        </div>
                        <span style="color: rgba(222, 222, 222, 0.2);margin-right:12px;">|</span>

                        <div style="width: 10%" class="number">

                            {{ item.operator.firstName }}{{ item.operator.lastName }}
                        </div>
                        <span style="color: rgba(222, 222, 222, 0.2);margin-right:12px;">|</span>

                        <div style="width: 20%" class="number">
                            {{ item.createTime | date:'HH:mm:ss dd/MM/yyyy' }}
                        </div>
                    </div>
                </mat-expansion-panel-header>

                <div fxLayout="column" fxFlex="60" style="margin-top: 20px;">
                    <div class="section" *ngIf="logDetail.log && logDetail.log.remark">
                        <div class="section-title">Message</div>
                        <div fxLayout="row wrap">
                            <div>{{logDetail.log.remark}}</div>
                        </div>
                    </div>

                    <div class="section" *ngIf="logDetail.commissionSetting">
                        <div class="section-title">Commission</div>
                        <div fxLayout="row wrap">
                            <div fxFlex="15" class="project-attr">
                                <div class="attr-name">Total commission</div>
                                <div class="attr-value">{{ logDetail.commissionSetting.total
                                    }}{{logDetail.commissionSetting.totalUnit==1?"%":"$"}}</div>
                            </div>

                            <div fxFlex="20" class="project-attr">
                                <div class="attr-name">Commission allocation plan</div>
                                <div class="attr-value" *ngIf="logDetail.commissionSetting.groupName == 1">Once-off
                                    Payment at Settlement</div>
                                <div class="attr-value" *ngIf="logDetail.commissionSetting.groupName == 2">Two-stage
                                    Payment</div>
                                <div class="attr-value" *ngIf="logDetail.commissionSetting.groupName == 3">3 stages
                                    Payment</div>
                            </div>

                            <div fxFlex="15" class="project-attr">
                                <div class="attr-name">Stage1</div>
                                <div class="attr-value">
                                    {{oneStage.activeValue}}{{logDetail.commissionSetting.totalUnit==1?"%":"$"}}</div>
                            </div>

                            <div fxFlex="15" class="project-attr" *ngIf="logDetail.commissionSetting.groupName != 1">
                                <div class="attr-name">Stage2</div>
                                <div class="attr-value">
                                    {{twoStage.activeValue}}{{logDetail.commissionSetting.totalUnit==1?"%":"$"}}</div>
                            </div>

                            <div fxFlex="15" class="project-attr" *ngIf="logDetail.commissionSetting.groupName == 3">
                                <div class="attr-name">Stage3</div>
                                <div class="attr-value">
                                    {{threeStage.activeValue}}{{logDetail.commissionSetting.totalUnit==1?"%":"$"}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div fxLayout="column" fxFlex="40" style="margin-top: 20px">
                    <div class="msg-doc" *ngIf="fileNames && fileNames.length > 0">
                        <div style="width: 100%">
                            <div class="title">Documents</div>
                            <div class="files-grid">
                                <div fxLayout="row" style="margin-bottom: 5px;justify-content: space-between"
                                    *ngFor="let item of fileNames">
                                    <div *ngIf="item" style="justify-content: space-between;display: flex">
                                        <mat-icon style="margin-right: 10px">insert_drive_file</mat-icon>
                                        <div>{{item}}</div>
                                    </div>
                                    <div *ngIf="item" style="justify-content: space-between;display: flex">
                                        <!--                                        <mat-icon style="margin-right: 10px">remove_red_eye</mat-icon>-->
                                        <mat-icon (click)="previewApplyFile(item,logDetail)">cloud_download</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize" style="background: #000"
        [pageSizeOptions]="pageSizeOptions" (page)="getSalesByPage(pageSize, $event)">
    </mat-paginator>
</div>